"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeBadges = exports.STORE_ITEM_TYPE = exports.PRODUCTS = exports.AVATAR_PRICE = void 0;
const badge_1 = require("./badge");
const career_1 = require("./career");
const STORE_ITEM_TYPE = {
    AVATAR: "a",
    BADGE: "b",
    DICE: "d",
    SEASON_AVATAR: "sa",
};
exports.STORE_ITEM_TYPE = STORE_ITEM_TYPE;
const PRODUCTS = {
    1: {
        value: 1,
        teeth: 10,
        title: "",
        description: "get 10 teeth",
        img: "coin1.jpeg",
    },
    5: {
        value: 5,
        teeth: 55,
        title: "",
        description: "get 55 teeth",
        img: "coin2.jpeg",
    },
    10: {
        value: 10,
        teeth: 115,
        title: "",
        description: "get 115 teeth",
        img: "coin3.jpeg",
    },
    15: {
        value: 15,
        teeth: 180,
        title: "",
        description: "get 180 teeth",
        img: "coin4.jpeg",
    },
    20: {
        value: 20,
        teeth: 250,
        title: "",
        description: "get 250 teeth",
        img: "coin5.jpeg",
    },
    30: {
        value: 30,
        teeth: 390,
        title: "",
        description: "get 390 teeth",
        img: "coin6.jpeg",
    },
    40: {
        value: 40,
        teeth: 540,
        title: "",
        description: "get 540 teeth",
        img: "coin7.jpeg",
    },
    80: {
        value: 80,
        teeth: 1120,
        title: "",
        description: "get 1120 teeth",
        img: "coin8.jpeg",
    },
};
exports.PRODUCTS = PRODUCTS;
const AVATAR_PRICE = {
    [career_1.AVATAR_RARITY.COMMUN]: 100,
    [career_1.AVATAR_RARITY.RARE]: 250,
    [career_1.AVATAR_RARITY.UNIQUE]: 390,
    [career_1.AVATAR_RARITY.SEASONAL]: 100,
};
exports.AVATAR_PRICE = AVATAR_PRICE;
const STORE_BADGE_PRICE = 180;
const storeBadges = {
    [badge_1.BADGE_NAMES.ELVEN_UNION]: {
        price: STORE_BADGE_PRICE,
        isUnique: true,
        isBadge: true,
    },
    [badge_1.BADGE_NAMES.SLANN]: {
        price: STORE_BADGE_PRICE,
        isUnique: true,
        isBadge: true,
    },
    [badge_1.BADGE_NAMES.SNOTLING]: {
        price: STORE_BADGE_PRICE,
        isUnique: true,
        isBadge: true,
    },
    [badge_1.BADGE_NAMES.IMPERIAL]: {
        price: STORE_BADGE_PRICE,
        isUnique: true,
        isBadge: true,
    },
    [badge_1.BADGE_NAMES.VAMPIRE]: {
        price: STORE_BADGE_PRICE,
        isUnique: true,
        isBadge: true,
    },
};
exports.storeBadges = storeBadges;
